
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { LandingLayout } from '@/components/layouts/LandingLayout';
import { TranslationProvider } from '@/context/translation';
import { createNonLocalizedPageGetServerSidePropsWithTranslations, type NonLocalizedPageWithTranslationsProps, } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const RealEstateLanding = dynamic(async () => await import('@/templates/Landing/RealEstate/RealEstateLanding'), {
    loading: LoaderScreen,
});
const index: React.FC<NonLocalizedPageWithTranslationsProps> = ({ locale, translations, }) => {
    return (<TranslationProvider locale={locale} translations={translations}>
			<LandingLayout title='Enhance Real Estate Listings with AI-Powered Photos | Lift' description='Lift transforms property images with AI: remove clutter, improve lighting, add virtual staging, and create listing visuals that drive engagement and sales.' ogTitle='Sell Faster with AI-Enhanced Real Estate Photos | Lift' ogDescription='Stand out in the real estate market with professional, AI-edited photos. Lift helps agents and landlords improve listings without expensive photo shoots.'>
				<RealEstateLanding />
			</LandingLayout>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createNonLocalizedPageGetServerSidePropsWithTranslations('/for-businesses/real-estate-listings', 'real-estate-listings');

    async function __Next_Translate__getServerSideProps__1a1a20bb8d4__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/for-businesses/real-estate-listings/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb8d4__ as getServerSideProps }
  